import { render, staticRenderFns } from "./schedule-form.vue?vue&type=template&id=72e3070c&scoped=true&"
import script from "./schedule-form.vue?vue&type=script&lang=js&"
export * from "./schedule-form.vue?vue&type=script&lang=js&"
import style0 from "./schedule-form.vue?vue&type=style&index=0&id=72e3070c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3070c",
  null
  
)

component.options.__file = "schedule-form.vue"
export default component.exports